const dropsealOption = { id: 1, type: "dropseal", label: "Add Drop Seal" };

export { dropsealOption };
